import React, { useContext, useState, useEffect } from 'react';
import HeaderForm from './headerform';
import {
  Navigate,
  useNavigate,
  Link
} from "react-router-dom";
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch } from "react-redux";
import { AppContext } from '../context';
import newlogos from '../assets/img/logo-new-jsry.png';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { toast } from "react-toastify";
import secureLocalStorage from "react-secure-storage";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormGroup from '@mui/material/FormGroup';
import Timer from './Timer';
function formatDate(date, format = null) {
  const myArray = date.split("-");
  var d = new Date(date);
  var month = myArray[1];
  var day = myArray[2];
  var year = myArray[0];
  var daten = month + '/' + day + '/' + year;
  // if (month.length < 2) month = '0' + month;
  // if (day.length < 2) day = '0' + day;

  // if (format && format == 'Y-m-d') return [month, day, year].join('-');
  // else return [month, day, year].join('-');
  return daten;
}
function sentenceCase(str) {
  if ((str === null) || (str === ''))
    return false;
  else
    str = str.toString();

  return str.replace(/\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() +
        txt.substr(1).toLowerCase();
    });
}
function ageCalculator(dob) {
  var userinput = dob;
  var dob = new Date(userinput);
  if (userinput == null || userinput == '') {
    document.getElementById("message").innerHTML = "**Choose a date Please!";
    return false;
  } else {

    //calculate month difference from current date in time  
    var month_diff = Date.now() - dob.getTime();

    //convert the calculated difference in date format  
    var age_dt = new Date(month_diff);

    //extract year from date      
    var year = age_dt.getUTCFullYear();

    //now calculate the age of the user  
    var age = Math.abs(year - 1970);

    //display the calculated age  
    return age;
  }
}
function userExists(arr, form_id) {
  return arr.some(function (el) {
    return el.form_id === form_id;
  });
}
function pdfExists(arr, document) {
  return arr.some(function (el) {
    return el.document === document;
  });
}

function FormStatus(props) {

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));

  function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  // const[reason,setReason]=React.useState(false)
  // const handlereason = () =>{
  //   setReason(true)
  // }


  const [manageapplicationstatusList, setManagApplicationsStatusList] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [reason, setReason] = React.useState(false)
  const [reasondeatils, setReasonDeatils] = React.useState('');
  const [nursedata, setNursedata] = React.useState('');
  const { storage } = useContext(AppContext);
  const [consentform, setConsentform] = React.useState(false);
  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  let navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [formDate, setformDate] = useState("");
  const [formtimecheck, setFormtimecheck] = React.useState('');
  const [isTimerComplete, setIsTimerComplete] = useState(false);
  const handleTimerComplete = () => {
    setIsTimerComplete(true);
  }
  const handleChangenew = (panel) => (event, isExpanded) => {
    setExpandednew(isExpanded ? panel : false);



  };
  const handleDownloadFileconscent = (stuid, formid, pdfname,id) => {

    Axios.get(`/parent/download-form-new/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, pdfname);
      })
  }
  const getFormData = (form_id) => {
    if (Array.isArray(allstudentlisdata)) {
      return allstudentlisdata.find(i => i.form_id == form_id);
    } else {
      return null;
    }
  }
  const [allstudentlisdata, setAllstudentlisdata] = useState([]);
  const [openLog, setOpenLog] = React.useState(false);
  const handleOpenLog = () => setOpenLog(true);
  const handleCloselog = () => setOpenLog(false);
  const [ipuser, setIpuser] = useState(null);
  const [formcheck, setFormcheck] = useState(null);
  const [horcheck, sethorcheck] = useState(false);
  const [userData, setuserData] = useState('');
  function handleKeyAccountPress(event) {
    const charCode = event.which || event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 189 && charCode <= 96 && charCode >= 105) {
      // The pressed key is not a number
      event.preventDefault();
    }
  }
  function handleKeyAccountPress(event) {
    const charCode = event.which || event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46 && charCode != 45) {
      // The pressed key is not a number
      event.preventDefault();
    }
  }
  const [datefir, setDatefir] = useState('');
  const [datesec, setDatesec] = useState('');
  const [dateth, setDateth] = useState('');
  const [datefor, setDatefor] = useState('');

  const [datefif, setDatefif] = useState('');
  const [datesix, setDatesix] = useState('');
  const [dateseven, setDateseven] = useState('');
  const [dateeight, setDateeight] = useState('');
  useEffect(() => {

    var user = JSON.parse(secureLocalStorage.getItem('userdata'));

    if (Object.keys(user).length === 0) {
      //  navigate(`/`);
    } else {
      setNursedata(user);
      var res = JSON.parse(secureLocalStorage.getItem('userdata'));

      if (JSON.parse(secureLocalStorage.getItem('studenentformdata')) != null && JSON.parse(secureLocalStorage.getItem('studenentformdata')) != undefined) {
        setAllstudentlisdata(JSON.parse(secureLocalStorage.getItem('studenentformdata')));
      }
      res.student_name = (sentenceCase(res.student_name));
      res.last_name = (sentenceCase(res.last_name));
      setuserData(res);
      console.log("user", (secureLocalStorage.getItem('consentForm')));
      if ((secureLocalStorage.getItem('consentForm')) != null && (secureLocalStorage.getItem('consentForm')) != undefined) {

        setUser((secureLocalStorage.getItem('consentForm')));
      }
      loadApplications();
      if (JSON.parse(secureLocalStorage.getItem('alldatafifthform')) != null && JSON.parse(secureLocalStorage.getItem('alldatafifthform')) != undefined) {
        setFifthforminInfo(JSON.parse(secureLocalStorage.getItem('alldatafifthform')));
      }

      var date = new Date();



      let day = date.getDate().toString().padStart(2, "0");
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let year = date.getFullYear().toString();
      let fromDate = `${day}-${month}-${year}`;
      let fDate = `${month}/${day}/${year}`;
      setDatefir(month.charAt(0));
      setDatesec(month.charAt(1));
  
      setDateth(day.charAt(0));
      setDatefor(day.charAt(1));
      setDatefif(year.charAt(0));
      setDatesix(year.charAt(1));
      setDateseven(year.charAt(2));
      setDateeight(year.charAt(3));
  
      setformDate(fDate);

    }
    axios.get("https://ipinfo.io/json")
      .then(res => {

        setIpuser(res.data.ip);



      }).catch(err => {

      })
  }, []);

  const handleDownloadFile = (stuid, formid, pdfname) => {

    Axios.get(`/parent/download-form/${stuid}/${formid}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, pdfname);
      })
  }
  const handlePhysicianDownloadFile = (id) => {
    let applItem = getApplicationRow(id);
    Axios.get(`/application/download-physician-form/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `physician_forms_${applItem.stuid}.zip`);
      })
  }

  const downloadBlob = (data, filename) => {
    // Create a blob from the res data
    const blob = new Blob([data], { type: data.type });

    // Create a link element
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);

  }
  const loadApplications = () => {
    var usernew = JSON.parse(secureLocalStorage.getItem('userdata'));
    if (usernew == null || usernew == undefined) {
      navigate(`/`);
    } else {
      setNursedata(usernew);
      Axios.post(`/appication_parentstatus_list`, { stuid: usernew.stuid })
        .then(res => {

          console.log("eform");
          console.log(res.data);
          // setTotalCount(res.data.pagination.totalCount);
          // setTotalPage(res.data.pagination.totalPage);
          if (res.data.status == true) {
            if (res.data.message.length > 0) {
              setManagApplicationsStatusList(res.data.message);
            } else {
              setManagApplicationsStatusList([]);
            }
          }


          setFirstLoading(false);
        });

      Axios.post(`/checkingforconsent`, { student_id: usernew.stuid })
        .then(res => {

          console.log("all student");
          console.log(res.data);

          if (res.data.status == true) {
            setFormtimecheck(res.data.data);
            setConsentform(true);
            if(res.data.data=='first'){
             // secureLocalStorage.removeItem("alldatafifthform");
            }
            setFormcheck(res.data.formcheck);
            sethorcheck(res.data.horcheck);

          }



        });
    }

  }
  const handleChangecheckpr = (event) => {
    if (checkprf == false) {
      setCheckprf(true);
    } else if (checkprf == true) {
      setCheckprf(false);
    }
  }
  const handlereason = (consent_form) => {
    setReasonDeatils(consent_form);
    setReason(true);

  }
  const getApplicationRow = (id) => {
    return manageapplicationstatusList.find(item => item.id == id);
  }

  const [checkprf, setCheckprf] = React.useState(false);
  const handleCloselogss = () => setReason(false);
  const [openLogacc, setOpenLogacc] = React.useState(false);
  const [valueacc, setAalueacc] = React.useState('');
  const handleOpenLogaccb = () => setOpenLogacc(true);
  const handleCloselogaccb = () => setOpenLogacc(false);
  const handleOpenLogacc = (val) => {
    setAalueacc(val);
    setCheckprf(false);
    setOpenLogacc(true);
  }

  const [expandednew, setExpandednew] = React.useState(false);

  var fifthform_default = {
    datefir: '',

    datefir_error: false,
    datesec: '',


    dateth: '',


    datefor: '',


    datefif: '',


    datesix: '',


    dateseven: '',


    dateeight: '',


    sports: '',

    sports_error: false,
    advised_not_participate: '',
    advised_not_participate_error: false,

    explain_advised_not_participate: '',
    explain_advised_not_participate_error: false,

    sustained_lost_memory: '',
    sustained_lost_memory_error: false,

    explain_sustained_lost_memory: '',
    explain_sustained_lost_memory_error: false,
    broken_bone: '',
    broken_bone_error: false,

    explain_broken_bone: '',
    explain_broken_bone_error: false,


    fainted: '',
    fainted_error: false,

    explain_fainted: '',
    explain_fainted_error: false,

    chest_pains: '',
    chest_pains_error: false,

    explain_chest_pains: '',
    explain_chest_pains_error: false,


    unusual_tiredness: '',
    unusual_tiredness_error: false,

    explain_unusual_tiredness: '',
    explain_unusual_tiredness_error: false,



    emergency_room: '',
    emergency_room_error: false,

    explain_emergency_room: '',
    explain_emergency_room_error: false,

    sudden_death_any_member: '',
    sudden_death_any_member_error: false,

    explain_sudden_death_any_member: '',
    explain_sudden_death_any_member_error: false,


    prescribed_medications: '',
    prescribed_medications_error: false,

    explain_prescribed_medications: '',
    explain_prescribed_medications_error: false,


    been_coronavirus: '',
    been_coronavirus_error: false,

    explain_been_coronavirus: '',
    explain_been_coronavirus_error: false,


    coronavirus_symptomatic: '',
    coronavirus_symptomatic_error: false,

    explain_coronavirus_symptomatic: '',
    explain_coronavirus_symptomatic_error: false,

    coronavirus_hospitalized: '',
    coronavirus_hospitalized_error: false,

    explain_coronavirus_hospitalized: '',
    explain_coronavirus_hospitalized_error: false,


    parent_signature: '',
    parent_signature_error: false,



  };

  const [fifthformInfo, setFifthforminInfo] = useState(fifthform_default);

  const [successMsgFifth, setSuccessMsgFifth] = useState('');
  const [errorMsgFifth, setErrorMsgFifth] = useState('');

  const [parentLoaderFifth, setparentLoaderFifth] = useState(false);

  const [openAllDownload, setOpenAllDownload] = useState(false);

  const handleChangeFifth = (event) => {
    var user_temp = { ...fifthformInfo };

    setSuccessMsgFifth('');
    setErrorMsgFifth('');
    user_temp.datefir_error = false;
    user_temp.sports_error = false;
    user_temp.advised_not_participate_error = false;
    user_temp.explain_advised_not_participate_error = false;
    user_temp.sustained_lost_memory_error = false;
    user_temp.explain_sustained_lost_memory_error = false;
    user_temp.broken_bone_error = false;
    user_temp.explain_broken_bone_error = false;
    user_temp.fainted_error = false;
    user_temp.explain_fainted_error = false;
    user_temp.chest_pains_error = false;
    user_temp.explain_chest_pains_error = false;
    user_temp.unusual_tiredness_error = false;
    user_temp.explain_unusual_tiredness_error = false;
    user_temp.emergency_room_error = false;
    user_temp.explain_emergency_room_error = false;
    user_temp.sudden_death_any_member_error = false;
    user_temp.explain_sudden_death_any_member_error = false;
    user_temp.prescribed_medications_error = false;
    user_temp.explain_prescribed_medications_error = false;
    user_temp.been_coronavirus_error = false;
    user_temp.explain_been_coronavirus_error = false;
    user_temp.coronavirus_symptomatic_error = false;
    user_temp.explain_coronavirus_symptomatic_error = false;
    user_temp.coronavirus_hospitalized_error = false;
    user_temp.explain_coronavirus_hospitalized_error = false;
    user_temp.parent_signature_error = false;


    if (event.target.name == "datefir") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefir = value;
      }
      document.getElementById('datesec_fif').focus();
    }
    if (event.target.name == "datesec") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datesec = value;
      }
      document.getElementById('dateth_fif').focus();
    }
    if (event.target.name == "dateth") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateth = value;
      }
      document.getElementById('datefor_fif').focus();
    }
    if (event.target.name == "datefor") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefor = value;
      }
      document.getElementById('datefif_fif').focus();

    }
    if (event.target.name == "datefif") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datefif = value;
      }
      document.getElementById('datesix_fif').focus();

    }
    if (event.target.name == "datesix") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.datesix = value;
      }
      document.getElementById('dateseven_fif').focus();


    }
    if (event.target.name == "dateseven") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateseven = value;
      }
      document.getElementById('dateeight_fif').focus();


    }
    if (event.target.name == "dateeight") {
      var value = event.target.value;

      if (value.length <= 1) {
        user_temp.dateeight = value;
      }

    }

    if (event.target.name == "sports") {
      user_temp.sports = event.target.value;

    }


    if (event.target.name == "advised_not_participate") {
      user_temp.advised_not_participate = event.target.value;

    }

    if (event.target.name == "explain_advised_not_participate") {
      console.log(event.target.name);
      console.log(event.target.value);
      user_temp.explain_advised_not_participate = event.target.value;

    }

    if (event.target.name == "sustained_lost_memory") {
      user_temp.sustained_lost_memory = event.target.value;

    }
    if (event.target.name == "explain_sustained_lost_memory") {
      user_temp.explain_sustained_lost_memory = event.target.value;

    }
    if (event.target.name == "broken_bone") {
      user_temp.broken_bone = event.target.value;

    }

    if (event.target.name == "explain_broken_bone") {
      user_temp.explain_broken_bone = event.target.value;

    }
    if (event.target.name == "fainted") {
      user_temp.fainted = event.target.value;

    }


    if (event.target.name == "explain_fainted") {
      user_temp.explain_fainted = event.target.value;

    }
    if (event.target.name == "chest_pains") {
      user_temp.chest_pains = event.target.value;

    }

    if (event.target.name == "explain_chest_pains") {
      user_temp.explain_chest_pains = event.target.value;

    }
    if (event.target.name == "unusual_tiredness") {
      user_temp.unusual_tiredness = event.target.value;

    }
    if (event.target.name == "explain_unusual_tiredness") {
      user_temp.explain_unusual_tiredness = event.target.value;

    }
    if (event.target.name == "emergency_room") {
      user_temp.emergency_room = event.target.value;

    }
    if (event.target.name == "explain_emergency_room") {
      user_temp.explain_emergency_room = event.target.value;

    }
    if (event.target.name == "sudden_death_any_member") {
      user_temp.sudden_death_any_member = event.target.value;

    }

    if (event.target.name == "explain_sudden_death_any_member") {
      user_temp.explain_sudden_death_any_member = event.target.value;

    }
    if (event.target.name == "prescribed_medications") {
      user_temp.prescribed_medications = event.target.value;

    }
    if (event.target.name == "explain_prescribed_medications") {
      user_temp.explain_prescribed_medications = event.target.value;

    }
    if (event.target.name == "been_coronavirus") {
      user_temp.been_coronavirus = event.target.value;

    }
    if (event.target.name == "explain_been_coronavirus") {
      user_temp.explain_been_coronavirus = event.target.value;

    }

    if (event.target.name == "coronavirus_symptomatic") {
      user_temp.coronavirus_symptomatic = event.target.value;

    }
    if (event.target.name == "explain_coronavirus_symptomatic") {
      user_temp.explain_coronavirus_symptomatic = event.target.value;

    }
    if (event.target.name == "coronavirus_hospitalized") {
      user_temp.coronavirus_hospitalized = event.target.value;

    }
    if (event.target.name == "explain_coronavirus_hospitalized") {
      user_temp.explain_coronavirus_hospitalized = event.target.value;

    }
    if (event.target.name == "parent_signature") {
      user_temp.parent_signature = event.target.value;

    }

    secureLocalStorage.setItem("alldatafifthform", JSON.stringify(user_temp));

    secureLocalStorage.setItem("oldstudid", (userData.stuid));
    setFifthforminInfo(user_temp);





  }
  const handleSubmitFifth = (event) => {

    setSuccessMsgFifth('');
    setErrorMsgFifth('');
    var user_temp = { ...fifthformInfo };



    user_temp.datefir_error = false;
    user_temp.sports_error = false;
    user_temp.advised_not_participate_error = false;
    user_temp.explain_advised_not_participate_error = false;
    user_temp.sustained_lost_memory_error = false;
    user_temp.explain_sustained_lost_memory_error = false;
    user_temp.broken_bone_error = false;
    user_temp.explain_broken_bone_error = false;
    user_temp.fainted_error = false;
    user_temp.explain_fainted_error = false;
    user_temp.chest_pains_error = false;
    user_temp.explain_chest_pains_error = false;
    user_temp.unusual_tiredness_error = false;
    user_temp.explain_unusual_tiredness_error = false;
    user_temp.emergency_room_error = false;
    user_temp.explain_emergency_room_error = false;
    user_temp.sudden_death_any_member_error = false;
    user_temp.explain_sudden_death_any_member_error = false;
    user_temp.prescribed_medications_error = false;
    user_temp.explain_prescribed_medications_error = false;
    user_temp.been_coronavirus_error = false;
    user_temp.explain_been_coronavirus_error = false;
    user_temp.coronavirus_symptomatic_error = false;
    user_temp.explain_coronavirus_symptomatic_error = false;
    user_temp.coronavirus_hospitalized_error = false;
    user_temp.explain_coronavirus_hospitalized_error = false;
    user_temp.parent_signature_error = false;


    if (user_temp.datefir == "") {
      user_temp.datefir_error = true;

      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.datesec == "") {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }


    if (user_temp.dateth == '') {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }


    if (user_temp.datefor == '') {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }
    if (user_temp.datefif == '') {

      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.datesix == '') {

      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.dateseven == '') {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.dateeight == "") {
      user_temp.datefir_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter date of last physical examination"); return false;
    }

    if (user_temp.sports == '') {
      user_temp.sports_error = true;

      setFifthforminInfo(user_temp);
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter sports name"); return false;
    }

    if (user_temp.advised_not_participate == '') {
      user_temp.advised_not_participate_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please select been medically advised not to participate in a sport?"); return false;
    }
    console.log(user_temp.explain_advised_not_participate);
    console.log(user_temp.advised_not_participate);


    if (user_temp.explain_advised_not_participate == ''
      && user_temp.advised_not_participate == 'Yes') {
      user_temp.explain_advised_not_participate_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain been medically advised not to participate in a sport?"); return false;
    }


    if (user_temp.sustained_lost_memory == '') {
      user_temp.sustained_lost_memory_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select sustained a concussion, been unconscious or lost memory from a blow to the head?"); return false;

    }
    if (user_temp.explain_sustained_lost_memory == ''
      && user_temp.sustained_lost_memory == 'Yes') {
      user_temp.explain_sustained_lost_memory_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain sustained a concussion, been unconscious or lost memory from a blow to the head?"); return false;
    }


    if (user_temp.broken_bone == '') {
      user_temp.broken_bone_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select broken a bone or sprained/strained/dislocated any muscle or joints?"); return false;

    }

    if (user_temp.explain_broken_bone == ''
      && user_temp.broken_bone == 'Yes') {
      user_temp.explain_broken_bone_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain broken a bone or sprained/strained/dislocated any muscle or joints?"); return false;
    }

    //         if (user_temp.explain_restricted== '' ) {
    // user_temp.explain_restricted_error=true;

    //       }
    if (user_temp.fainted == '') {
      user_temp.fainted_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select fainted or blacked out?"); return false;


    }
    if (user_temp.explain_fainted == ''
      && user_temp.fainted == 'Yes') {
      user_temp.explain_fainted_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain fainted or blacked out?"); return false;
    }



    //        if (user_temp.explain== '') {
    // user_temp.explain_error=true;

    //       }
    if (user_temp.chest_pains == '') {
      user_temp.chest_pains_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select experienced chest pains, shortness of breath or racing heart?"); return false;

    }
    if (user_temp.explain_chest_pains == ''
      && user_temp.chest_pains == 'Yes') {
      user_temp.explain_chest_pains_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain experienced chest pains, shortness of breath or racing heart?"); return false;
    }




    //        if (user_temp.explain_exercise== '') {
    // user_temp.explain_exercise_error=true;

    //       }
    if (user_temp.unusual_tiredness == '') {
      user_temp.unusual_tiredness_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select has there been a recent history of fatigue and unusual tiredness?"); return false;


    }

    if (user_temp.explain_unusual_tiredness == ''
      && user_temp.unusual_tiredness == 'Yes') {
      user_temp.explain_unusual_tiredness_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain has there been a recent history of fatigue and unusual tiredness?"); return false;
    }

    //        if (user_temp.explain_chest== '') {
    // user_temp.explain_chest_error=true;

    //       }
    if (user_temp.emergency_room == '') {
      user_temp.emergency_room_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select been hospitalized or had to go to the emergency room?"); return false;


    }

    if (user_temp.explain_emergency_room == ''
      && user_temp.emergency_room == 'Yes') {
      user_temp.explain_emergency_room_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  been hospitalized or had to go to the emergency room?"); return false;

    }

    //        if (user_temp.explain_irregular== '') {
    // user_temp.explain_irregular_error=true;

    //       }
    if (user_temp.sudden_death_any_member == '') {
      user_temp.sudden_death_any_member_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select since the last physical examination, has there been a sudden death in the family or has any member of the family under age 50 had a heart attack or heart trouble?"); return false;


    }

    if (user_temp.explain_sudden_death_any_member == ''
      && user_temp.sudden_death_any_member == 'Yes') {
      user_temp.explain_sudden_death_any_member_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  since the last physical examination, has there been a sudden death in the family or has any member of the family under age 50 had a heart attack or heart trouble?"); return false;
    }


    if (user_temp.prescribed_medications == '') {
      user_temp.prescribed_medications_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select started or stopped taking any over-the-counter or prescribed medications?"); return false;


    }

    if (user_temp.explain_prescribed_medications == ''
      && user_temp.prescribed_medications == 'Yes') {
      user_temp.explain_prescribed_medications_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  started or stopped taking any over-the-counter or prescribed medications?"); return false;
    }

    //        if (user_temp.explain_heart_doctor== '') {
    // user_temp.explain_heart_doctor_error=true;

    //       }

    //        if (user_temp.explain_lightheaded== '') {
    // user_temp.explain_lightheaded_error=true;

    //       }
    if (user_temp.been_coronavirus == '') {
      user_temp.been_coronavirus_error = true;

      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select been diagnosed with Coronavirus (COVID-19)?"); return false;

    }
    if (user_temp.explain_been_coronavirus == ''
      && user_temp.been_coronavirus == 'Yes') {
      user_temp.explain_been_coronavirus_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  been diagnosed with Coronavirus (COVID-19)?"); return false;
    }

    //        if (user_temp.explain_seizure== '') {
    // user_temp.explain_seizure_error=true;

    //       }



    if (user_temp.coronavirus_symptomatic == '') {
      user_temp.coronavirus_symptomatic_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select if diagnosed with Coronavirus (COVID-19), was your son/daughter symptomatic?"); return false;


    }

    if (user_temp.explain_coronavirus_symptomatic == ''
      && user_temp.coronavirus_symptomatic == 'Yes') {
      user_temp.explain_coronavirus_symptomatic_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  if diagnosed with Coronavirus (COVID-19), was your son/daughter symptomatic?"); return false;
    }

    //        if (user_temp.explain_breath== '') {
    // user_temp.explain_breath_error=true;

    //       }

    if (user_temp.coronavirus_hospitalized == '') {
      user_temp.coronavirus_hospitalized_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please select if diagnosed with Coronavirus (COVID-19), was your son/daughter hospitalized?"); return false;


    }
    if (user_temp.explain_coronavirus_hospitalized == ''
      && user_temp.coronavirus_hospitalized == 'Yes') {
      user_temp.explain_coronavirus_hospitalized_error = true;

      setFifthforminInfo(user_temp);

      setErrorMsgFifth("Please explain  if diagnosed with Coronavirus (COVID-19), was your son/daughter hospitalized?"); return false;
    }


    if (user_temp.parent_signature == '') {
      user_temp.parent_signature_error = true;
      setFifthforminInfo(user_temp);
      setErrorMsgFifth("Please enter signature of parent/guardian"); return false;


    }

    setparentLoaderFifth(true);
    user_temp.date = user_temp.datefif + user_temp.datesix + user_temp.dateseven + user_temp.dateeight + '-' + user_temp.datefir + user_temp.datesec + '-' + user_temp.dateth + user_temp.datefor;
    setOpenLog(true);
    Axios.post(`/pdf_connset_form`, { studid: userData.stuid, id: 5, formdata: user_temp, ip_address: ipuser, formtimecheck: formtimecheck })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          console.log(res.data.data);
          var arrst = [];
          var docnew = {};
          var resultnew = res.data.studentdata.map(function (el) {
            var o = Object.assign({}, el);
            if (o.form_id == 5) {
              docnew = o;

            }


            //return o;
          });
          console.log(docnew);
          console.log(allstudentlisdata);
          if (allstudentlisdata.length > 0) {
            arrst.push(docnew);
            var resultk = allstudentlisdata.map(function (el) {
              var ou = Object.assign({}, el);

              if (ou.form_id != 5) {


                arrst.push(ou);
              } else {

              }

              console.log(allstudentlisdata);
              console.log(ou);

              return ou;
            });
          } else {
            arrst.push(docnew);
          }

          console.log(arrst);
          setAllstudentlisdata(arrst);
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));


          Axios.post(`/checkingforconsent`, { student_id: userData.stuid })
            .then(res => {

              console.log("all student");
              console.log(res.data);

              if (res.data.status == true) {
                setFormtimecheck(res.data.data);
                setConsentform(true);
                setFormcheck(res.data.formcheck);
                sethorcheck(res.data.horcheck);

              }



            });
          // storage[0].userdata = res.data.data;
          // secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          // setAllstudentlisdata(res.data.studentdata);
          setparentLoaderFifth(false);
          setSuccessMsgFifth('Form Submitted Successfully');
          setOpenLog(false);
          setTimeout(function () {
            setOpenLog(false);
            setSuccessMsgFifth('');
            setErrorMsgFifth('');

          }, 1000);

        }
        else {

          setErrorMsgFifth(res.data.data);
          setparentLoaderFifth(false);
        }

      })
      .catch(error => {
        setErrorMsgFifth('Network Connection Problem, please try again!');
        setparentLoaderFifth(false);

      });

  }
  const handleReqFormDownload = () => {
    handleAllDownload();
  }

  const handleAllDownload = () => {
    setAllFromDownloadSuccess(null);
    setAllFromDownloadError(null);
    setOpenAllDownload(true);
    setDownloadFroms({});
  }

  const closeAllDownload = () => {
    setOpenAllDownload(false);
  }
  const handleEdit = (val) => {
    console.log(val);

    if (val == 5) {
      secureLocalStorage.removeItem("alldatafifthform");
      setFifthforminInfo(fifthform_default);
      setFormcheck(null);
    }

    // var arrst = [];

    // var result = allstudentlisdata.map(function (el) {
    //   var o = Object.assign({}, el);
    //   if (o.form_id != val) {
    //     arrst.push(o);
    //   }
    //   console.log(allstudentlisdata);
    //   console.log(o);

    //   return o;
    // });
    // console.log(arrst);
    // setAllstudentlisdata(arrst);
    // secureLocalStorage.setItem("studenentformdata", JSON.stringify(arrst));
    setOpenLogacc(false);

  }
  const [downloadFroms, setDownloadFroms] = useState({});
  const [allFormDownloadProcess, setAllFormDownloadProcess] = useState(false);
  const [allFromDownloadSuccess, setAllFromDownloadSuccess] = useState(null);
  const [allFromDownloadError, setAllFromDownloadError] = useState(null);
  const handleOnChangeDownloadForm = (e) => {
    const { name, checked } = e.target;
    setDownloadFroms({ ...downloadFroms, [name]: checked });
  }

  const handleDownloadAllFromSubmit = () => {
    if (allFormDownloadProcess) return;
    setAllFormDownloadProcess(true);

    let formIds = [];
    let downloadFromsK = Object.keys(downloadFroms);
    for (let i = 0; i < downloadFromsK.length; i++) {
      if (downloadFroms[downloadFromsK[i]]) {
        formIds.push(downloadFromsK[i].split('_')[1]);
      }
    }

    Axios.post(`/parentformsend`, { studid: userData.stuid, form_id: formIds.join(",") })
      .then(res => {
        if (res.data.status) {
          setAllFromDownloadSuccess(res.data.message);
          setTimeout(() => {
            closeAllDownload();
            setAllFromDownloadSuccess(null);
          }, 2000);
        } else {
          setAllFromDownloadError(res.data.message);
        }
        setAllFormDownloadProcess(false);
      }).catch(error => {
        setAllFromDownloadError('Network Connection Problem, please try again!');
      })
  }

  const allForms = [{
    lable: "CONSENT FORM FOR INTERSCHOLASTIC ATHLETICS",
    id: 1
  }, {
    lable: "PREPARTICIPATION PHYSICAL EVALUATION | HISTORY FORM",
    id: 3
  }, {
    lable: "PREPARTICIPATION  PHYSICAL  EVALUATION | THE ATHLETE WITH SPECIAL NEEDS: SUPPLEMENTAL HISTORY FORM",
    id: 4
  }, {
    lable: "NEW JERSEY DEPARTMENT OF EDUCATION HEALTH HISTORY UPDATE QUESTIONNAIRE",
    id: 5
  }, {
    lable: "SPORTS-RELATED CONCUSSION AND HEAD INJURY FACT SHEET AND PARENT/GUARDIAN ACKNOWLEDGEMENT FORM",
    id: 6
  }, {
    lable: "SUDDEN CARDIAC DEATH PAMPHLET SIGN-OFF SHEET",
    id: 7
  }, {
    lable: "USE AND MISUSE OF OPIOID DRUGS FACT SHEET",
    id: 8
  }, {
    lable: "NJSIAA OPIOID POLICY ACKNOWLEDGEMENT",
    id: 9
  }, {
    lable: "NJSIAA STEROID TESTING POLICY CONSENT TO RANDOM TESTING",
    id: 10
  }];

  const getCompletedForms = () => {
    let completedForms = [];
    if (Array.isArray(allstudentlisdata)) {
      for (let i = 0; i < allForms.length; i++) {
        let x = allstudentlisdata.find(j => j.form_id == allForms[i].id);
        if (x) {
          completedForms.push(allForms[i]);
        }
      }
    }
    return completedForms;
  }

  const checkIsAllFormChecked = () => {
    let downloadFromsK = Object.keys(downloadFroms);
    for (let i = 0; i < downloadFromsK.length; i++) {
      if (downloadFroms[downloadFromsK[i]]) {
        return true;
      }
    }
    return false;
  }


  return (
    <>
      <HeaderForm />

      <div className='regis-main-sec forms-main-sec'>
        <div className='container-fluid'>

          <div className='row'>
            <div className='col-md-12'>
              <div className='regis-head forms-heading-sec'>
                <h2>Application Status</h2>
                {user != null ?
                  <>

                    {(user.status != 'Approved' && user.status != 'Rejected') &&
                      <>
                        <Link to="/forms">  <p className='stts-sec view-sts go-frm-cols'>
                          <span className='go-new-add'>GO TO FORM CONSOLE</span>

                          <div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
                            <div class="scroll-prompt-arrow-container">
                              <div class="scroll-prompt-arrow"><div></div></div>
                              <div class="scroll-prompt-arrow new-scroll"><div></div></div>
                            </div>
                          </div>

                        </p></Link>
                      </>
                    }

                  </>
                  :
                  <>

                    <Link to="/forms">  <p className='stts-sec view-sts go-frm-cols'>
                      <span className='go-new-add'>GO TO FORM CONSOLE</span>

                      <div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
                        <div class="scroll-prompt-arrow-container">
                          <div class="scroll-prompt-arrow"><div></div></div>
                          <div class="scroll-prompt-arrow new-scroll"><div></div></div>
                        </div>
                      </div>

                    </p></Link>

                  </>
                }

              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='club-sec application-sec'>
                <div className='container-fluid '>

                  <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='form-uplg form-uplg-new'>
                          {manageapplicationstatusList.length > 0 ?
                            <>
                              {
                                manageapplicationstatusList.map((userd, index) =>
                                  <>

                                    {(userd.pending_parent_form != 0) && <p style={{ color: '#f19103' }}> {userd.pending_parent_form} forms pending to complete your application</p>}
                                    {(userd.pending_parent_form == 0) && <p style={{ color: '#059652' }}>All forms uploaded</p>}

                                  </>
                                )
                              }
                            </>
                            : ''}

                        </div>
                        <div className='indicate-secss'>
                          <p className='style-new style-new-ntk'><span className='square-secss'><span className='new-round-redss new-app-yellow'><span className='new-roud-val'>P</span></span><span className='dash-sec-nwe'> - </span> </span><span style={{ color: '#f19103', fontWeight: '700' }}>Pending</span></p>
                          <p className='style-new style-new-ntk'><span className='square-secss'><span className='new-round-redss new-app-green'><span className='new-roud-val'>A</span></span> <span className='dash-sec-nwe'> - </span> </span><span style={{ color: '#059652', fontWeight: '700' }}>Approved</span></p>
                          <p className='style-new-ntk'><span className='square-sec-redsss '><span className='new-round-redss'><span className='new-roud-val'>R</span></span><span className='dash-sec-nwe'> - </span></span><span style={{ color: '#fb0b0b', fontWeight: '700' }}>Rejected</span></p>
                        </div>

                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <table class="table table-bordered">
                          <thead class="thead-light thead-travel thead-form">
                            <tr>
                              <th className='loc-width'>Location</th>
                              <th className='std-id-width'>Student ID</th>
                              <th className='std-name-width'>Student Name</th>
                              <th className='grade-width'>Grade</th>
                              {/* <th className='date-width'>Parent Consent Form</th>
                              <th className='date-width'>Physician Form</th> */}
                              <th className='stts-width'>Status</th>
                            </tr>
                          </thead>
                          <tbody className='tbody-light tbody-form'>
                            {
                              firstLoading ? <tr ><td colSpan={7}><div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div></td></tr> : <>
                                {manageapplicationstatusList.length > 0 ?

                                  manageapplicationstatusList.map((userd, index) =>
                                    <tr key={index}>

                                      <td>{userd.school_name}</td>
                                      <td className='std-id'>{userd.stuid}</td>
                                      <td>{userd.student_name} {userd.last_name}</td>
                                      <td>{userd.stu_grade}</td>
                                      {/* <td><p className='form-comp'>
                             {userd.document_details.length >0 && userd.document_details.length}
                              
                    <span className={` ${(userd.pending_parent_form != 0) && 'red-down'} ${(userd.pending_parent_form == 0) && 'blue-down'}`}>
                    <a  title="Download"><DownloadIcon  onClick={() => handleDownloadFile(userd.id)} title="Download"
                    /></a></span></p>
                    
                    </td> */}
                                      {/* <td><p className='form-comp'>
                    
                             {userd.physician_document_details.length >0 && userd.physician_document_details.length}
                              {userd.physician_document_details.length>0 &&
    <span className={`  ${(userd.physician_document_details.length >0) && 'blue-down'}`}>
    <a  title="Download"><DownloadIcon  onClick={() => handlePhysicianDownloadFile(userd.id)} 
                    />
                    </a></span>
                              }
                   
                    </p>
                    </td> */}
                                      <td>
                                        <div className='round-stss'>

                                          <span className=
                                            {`green-down ${(userd.consent_details.status == 'Rejected') ? 'square-sec-redss new-round-red' : (userd.consent_details.status == 'Pending' ? 'pend-sts round-pend' : 'round-approve')}`} style={{ fontWeight: '700', fontSize: '17px' }}>
                                            {(userd.consent_details.status == 'Rejected') && 'R'}
                                            {(userd.consent_details.status == 'Pending') && 'P'}
                                            {(userd.consent_details.status == 'Approved') && 'A'}</span>

                                          {(userd.consent_details.status == 'Approved' || userd.consent_details.status == 'Rejected') &&
                                            <div className='stst-visi'>
                                              <span className='visib-sec'
                                                onClick={() => handlereason(userd.consent_details)}><VisibilityIcon /></span></div>}
                                        </div>
                                      </td>






                                    </tr>
                                  )

                                  : <tr><td colSpan={7}>No Data Found</td></tr>}
                              </>
                            }

                          </tbody>

                        </table>
                      </div>
                    </div>

                  </div>

                  {(consentform == true && horcheck==true) &&
                    <>

                      <div className='forms-nme-sec'>
                        <div className='row'>
                          <div className='col-md-12'>
                            <div className='form-accor newquestionform'>
                              <div className='form-accor-sec color-form-occur'>
                                <div className='regis-head forms-heading-sec'>
                                <h2> 90 Days Evaluation Form</h2>
                                </div>
                              
                                {formtimecheck == 'first' &&

                                  <>

                                    <Accordion expanded={expandednew === 'panel5f'} onChange={handleChangenew('panel5f')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel3-content"
                                        id="panel3-header"
                                      >
                                        <Typography sx={{ width: '80%', flexShrink: 0 }}>NEW JERSEY DEPARTMENT OF EDUCATION HEALTH HISTORY UPDATE QUESTIONNAIRE</Typography>
                                        <Typography className="green-dwn" sx={{ flexShrink: 0, color: 'text.secondary', float: 'right', width: '20%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                          <span className='pebdingarmh'>Pending</span>
                                        </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <Typography>
                                          <div className='form-main-sec'>
                                            <div className='date-form'>







                                              <div className='row'>
                                                <div className='col-md-2'>
                                                  <div className='heading-logo'>
                                                    <img src={newlogos} style={{ top: '15px' }} />
                                                  </div>
                                                </div>
                                                <div className='col-md-8'>
                                                  <div className='heading-form-para'>
                                                    <h1>New Jersey Department of Education </h1>
                                                    <h2>HEALTH HISTORY UPDATE QUESTIONNAIRE</h2>


                                                  </div>
                                                </div>

                                              </div>
                                              <div className='row'>


                                                <div class="form-date-sec update-schl">
                                                  <label>Name of School</label>
                                                  <span className='colon'>:</span>
                                                  <span className='schol-name '>{userData.school_name}</span></div>
                                              </div>
                                              <div className='row'>
                                                <div className='col-md-12'>
                                                  <div className='form-content-sec form-content-secss'>
                                                    <p>To participate on a school-sponsored interscholastic or intramural athletic team or squad, each student whose physical examination was completed more than 90 days prior
                                                      to the first day of official practice shall provide a health history update questionnaire completed and signed by the student's parent or guardian.</p>
                                                  </div>
                                                </div>
                                              </div>


                                              <div class="row margin-data ques-margin-dta">
                                                <div class="col-md-3">

                                                  <div class="form-inner ony-wid-main">
                                                    <h2 className='ony-wid-name ony-wid-namess'>Student Name</h2>
                                                    <p>:</p>
                                                    <p class="id-sec width-extra ony-wid-exta">{userData.student_name} {userData.last_name}</p></div>
                                                </div>
                                                <div class="col-md-2">

                                                  <div class="form-inner new-form-inner extranew-inn">
                                                    <h2>Age </h2>
                                                    <p>:</p>
                                                    <p class="form-data width-extra"> {(userData.dob != null && userData.dob != '') && ageCalculator(userData.dob)}</p>
                                                  </div>
                                                </div>
                                                <div class="col-md-2">

                                                  <div class="form-inner new-form-inner extranew-inns">
                                                    <h2>Grade</h2>
                                                    <p>:</p>
                                                    <p class="id-sec width-extra"> {userData.stu_grade}</p>
                                                  </div>
                                                </div>
                                                <div class="col-md-5">



                                                  <div className='form-date-sec form-date-nbw'>
                                                    <label className="width-labl" style={{ top: '3px' }}>Date of Last Physical Examination</label>

                                                    <div className='date-sec date-text-nwd'>
                                                      <div className='date-slash'>
                                                        <input type="text" className="textmntg"
                                                          id="datefir_fif" onKeyPress={(e) => handleKeyAccountPress(e)} placeholder='m'
                                                          value={fifthformInfo.datefir} onChange={handleChangeFifth}
                                                          name="datefir" />
                                                        <input type="text" onKeyPress={(e) => handleKeyAccountPress(e)} className="textmntg" placeholder='m'
                                                          value={fifthformInfo.datesec} id="datesec_fif"
                                                          onChange={handleChangeFifth}
                                                          name="datesec" />

                                                      </div>
                                                      <div className='date-slash'>
                                                        <p >-</p>
                                                      </div>
                                                      <div className='date-slash'>
                                                        <input type="text" className="textdate textmonthstg" placeholder='d'
                                                          value={fifthformInfo.dateth} id="dateth_fif" onKeyPress={(e) => handleKeyAccountPress(e)}
                                                          onChange={handleChangeFifth}
                                                          name="dateth" />
                                                        <input type="text" id="datefor_fif" className="textdate textmonthstg" placeholder='d'
                                                          value={fifthformInfo.datefor} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeFifth}
                                                          name="datefor" />
                                                      </div>
                                                      <div className='date-slash'>
                                                        <p >-</p>
                                                      </div>
                                                      <div className='date-slash'>
                                                        <input type="text" id="datefif_fif" className="textdate textyeartg" placeholder='y'
                                                          value={fifthformInfo.datefif} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeFifth}
                                                          name="datefif" />
                                                        <input type="text" id="datesix_fif" className="textdate textyeartg" placeholder='y'
                                                          value={fifthformInfo.datesix} onChange={handleChangeFifth} onKeyPress={(e) => handleKeyAccountPress(e)}
                                                          name="datesix" />
                                                        <input type="text" id="dateseven_fif" className="textdate textyeartg"
                                                          value={fifthformInfo.dateseven} onChange={handleChangeFifth} onKeyPress={(e) => handleKeyAccountPress(e)}
                                                          name="dateseven" placeholder='y' />
                                                        <input type="text" id="dateeight_fif" className="textdate textyeartg"
                                                          value={fifthformInfo.dateeight} onChange={handleChangeFifth} onKeyPress={(e) => handleKeyAccountPress(e)}
                                                          name="dateeight" placeholder='y' />
                                                      </div>


                                                    </div>


                                                  </div>

                                                  <p className='error-msg-frm ' style={{ textAlign: 'center' }}>
                                                    <span>
                                                      {fifthformInfo.datefir_error == true ? 'Please enter date of last physical examination' : ''}
                                                    </span>
                                                  </p>

                                                </div>

                                              </div>
                                              <div class="row margin-data">
                                                <div class="col-md-6">

                                                  <div class="form-inner form-date-sec form-sportss form-new-sportsss">
                                                    <h2>Sport(s)</h2>
                                                    <p>:</p>
                                                    <input type="text" class="text-datess new-border"
                                                      value={fifthformInfo.sports} onChange={handleChangeFifth}
                                                      name="sports" />
                                                    <div style={{ position: 'relative', display: 'block' }} >
                                                      <p className='error-msg-frm error-sbso ' style={{ textAlign: 'center', marginLeft: '0px', position: 'absolute' }}>
                                                        {fifthformInfo.sports_error == true ? 'Please enter the sports' : ''}

                                                      </p>
                                                    </div>

                                                  </div>
                                                </div>

                                              </div>
                                              <div class="row">
                                                <div class="col-md-12">
                                                  <div class="physici-sec-head">
                                                    <h2>Since the last pre-participation physical examination, has your son/daughter</h2>
                                                  </div>
                                                </div>
                                              </div>



                                              <div className='medi-details-sec gener-ques'>


                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">1.</p><p class="num-data-sec"> Been medically advised not to participate in a sport?</p>
                                                        </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="advised_not_participate" checked={fifthformInfo.advised_not_participate == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="advised_not_participate" checked={fifthformInfo.advised_not_participate == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />


                                                          <div className='fied-miss'>
                                                            {fifthformInfo.advised_not_participate_error == true ? 'Field missing ' : ''}
                                                          </div>

                                                        </RadioGroup>



                                                      </div>
                                                    </div>


                                                    {fifthformInfo.advised_not_participate == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_advised_not_participate}
                                                              onChange={handleChangeFifth}
                                                              name="explain_advised_not_participate" type="text" id="fname"
                                                              placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_advised_not_participate_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}

                                                  </FormControl>
                                                </div>

                                                <div class="" style={{ marginTop: '0px' }}>
                                                  <hr />
                                                </div>
                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">2.</p><p class="num-data-sec"> Sustained a concussion, been unconscious or lost memory from a blow to the head? </p>
                                                        </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="sustained_lost_memory" checked={fifthformInfo.sustained_lost_memory == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="sustained_lost_memory" checked={fifthformInfo.sustained_lost_memory == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                          <div className='fied-miss'>
                                                            {fifthformInfo.sustained_lost_memory_error == true ? 'Field missing ' : ''}
                                                          </div>

                                                        </RadioGroup>



                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>

                                                {fifthformInfo.sustained_lost_memory == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_sustained_lost_memory} onChange={handleChangeFifth}
                                                          name="explain_sustained_lost_memory" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_sustained_lost_memory_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}
                                                <div class="" style={{ marginTop: '0px' }}>
                                                  <hr />
                                                </div>

                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">3.</p><p class="num-data-sec"> Broken a bone or sprained/strained/dislocated any muscle or joints? </p>
                                                        </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="broken_bone" checked={fifthformInfo.broken_bone == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="broken_bone" checked={fifthformInfo.broken_bone == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                          <div className='fied-miss'>
                                                            {fifthformInfo.broken_bone_error == true ? 'Field missing' : ''}
                                                          </div>

                                                        </RadioGroup>



                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>

                                                {fifthformInfo.broken_bone == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_broken_bone} onChange={handleChangeFifth}
                                                          name="explain_broken_bone" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_broken_bone_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}
                                                <div class="" style={{ marginTop: '0px' }}>
                                                  <hr />
                                                </div>

                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">4.</p><p class="num-data-sec"> Fainted or "blacked out?"  </p>
                                                        </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="fainted" checked={fifthformInfo.fainted == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="fainted" checked={fifthformInfo.fainted == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                          <div className='fied-miss'>
                                                            {fifthformInfo.fainted_error == true ? 'Field missing' : ''}
                                                          </div>
                                                        </RadioGroup>



                                                      </div>
                                                    </div>


                                                    {fifthformInfo.fainted == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>If yes, was this during or immediately after exercise?

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_fainted} onChange={handleChangeFifth}
                                                              name="explain_fainted" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_fainted_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}


                                                  </FormControl>
                                                </div>
                                                <div class="" style={{ marginTop: '0px' }}>
                                                  <hr />
                                                </div>
                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">5.</p><p class="num-data-sec">  Experienced chest pains, shortness of breath or "racing heart?"  </p>
                                                        </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="chest_pains" checked={fifthformInfo.chest_pains == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="chest_pains" checked={fifthformInfo.chest_pains == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                          <div className='fied-miss'>
                                                            {fifthformInfo.chest_pains_error == true ? 'Field missing' : ''}
                                                          </div>

                                                        </RadioGroup>


                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>

                                                {fifthformInfo.chest_pains == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_chest_pains} onChange={handleChangeFifth}
                                                          name="explain_chest_pains" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_chest_pains_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}
                                                <div class="" style={{ marginTop: '0px' }}>
                                                  <hr />
                                                </div>
                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">6.</p><p class="num-data-sec"> Has there been a recent history of fatigue and unusual tiredness?  </p>
                                                        </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="unusual_tiredness" checked={fifthformInfo.unusual_tiredness == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="unusual_tiredness" checked={fifthformInfo.unusual_tiredness == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                          <div className='fied-miss'>
                                                            {fifthformInfo.unusual_tiredness_error == true ? 'Field missing' : ''}
                                                          </div>

                                                        </RadioGroup>


                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>

                                                {fifthformInfo.unusual_tiredness == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_unusual_tiredness} onChange={handleChangeFifth}
                                                          name="explain_unusual_tiredness" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_unusual_tiredness_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}
                                                <div class="" style={{ marginTop: '0px' }}>
                                                  <hr />
                                                </div>
                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">7.</p><p class="num-data-sec"> Been hospitalized or had to go to the emergency room?</p>
                                                        </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="emergency_room" checked={fifthformInfo.emergency_room == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="emergency_room" checked={fifthformInfo.emergency_room == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                          <div className='fied-miss'>
                                                            {fifthformInfo.emergency_room_error == true ? 'Field missing' : ''}
                                                          </div>

                                                        </RadioGroup>



                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>

                                                {fifthformInfo.emergency_room == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_emergency_room} onChange={handleChangeFifth}
                                                          name="explain_emergency_room" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_emergency_room_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}
                                                <div class="" style={{ marginTop: '0px' }}>
                                                  <hr />
                                                </div>

                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">8.</p><p class="num-data-sec"> Since the last physical examination, has there been a sudden death in the family or has any member of the family under age
                                                            50 had a heart attack or "heart trouble?" </p></FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="sudden_death_any_member" checked={fifthformInfo.sudden_death_any_member == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="sudden_death_any_member" checked={fifthformInfo.sudden_death_any_member == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                          <div className='fied-miss'>
                                                            {fifthformInfo.sudden_death_any_member_error == true ? 'Field missing ' : ''}
                                                          </div>
                                                        </RadioGroup>


                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>

                                                {fifthformInfo.sudden_death_any_member == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_sudden_death_any_member} onChange={handleChangeFifth}
                                                          name="explain_sudden_death_any_member" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_sudden_death_any_member_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}
                                                <div class="" style={{ marginTop: '0px' }}>
                                                  <hr />
                                                </div>

                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">9.</p><p class="num-data-sec"> Started or stopped taking any over-the-counter or prescribed medications?</p>  </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="prescribed_medications" checked={fifthformInfo.prescribed_medications == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="prescribed_medications" checked={fifthformInfo.prescribed_medications == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                          <div className='fied-miss'>
                                                            {fifthformInfo.prescribed_medications_error == true ? 'Field missing ' : ''}
                                                          </div>
                                                        </RadioGroup>



                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>


                                                {fifthformInfo.prescribed_medications == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_prescribed_medications} onChange={handleChangeFifth}
                                                          name="explain_prescribed_medications" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_prescribed_medications_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}
                                                <div class="" style={{ marginTop: '0px' }}>
                                                  <hr />
                                                </div>

                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          <p class="num-sec">10.</p><p class="num-data-sec">   Been diagnosed with Coronavirus (COVID-19)? </p>   </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="been_coronavirus" checked={fifthformInfo.been_coronavirus == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="been_coronavirus" checked={fifthformInfo.been_coronavirus == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                          <div className='fied-miss'>
                                                            {fifthformInfo.been_coronavirus_error == true ? 'Field missing ' : ''}
                                                          </div>

                                                        </RadioGroup>


                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>

                                                {fifthformInfo.been_coronavirus == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_been_coronavirus} onChange={handleChangeFifth}
                                                          name="explain_been_coronavirus" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_been_coronavirus_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}

                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          If diagnosed with Coronavirus (COVID-19), was your son/daughter symptomatic? </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="coronavirus_symptomatic" checked={fifthformInfo.coronavirus_symptomatic == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="coronavirus_symptomatic" checked={fifthformInfo.coronavirus_symptomatic == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                          <div className='fied-miss'>
                                                            {fifthformInfo.coronavirus_symptomatic_error == true ? 'Field missing' : ''}
                                                          </div>

                                                        </RadioGroup>



                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>

                                                {fifthformInfo.coronavirus_symptomatic == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_coronavirus_symptomatic} onChange={handleChangeFifth}
                                                          name="explain_coronavirus_symptomatic" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_coronavirus_symptomatic_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}


                                                <div className='radio-sec-medi-details radio-above'>
                                                  <FormControl>
                                                    <div className='row'>
                                                      <div className='col-md-6'>
                                                        <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                          If diagnosed with Coronavirus (COVID-19), was your son/daughter hospitalized?  </FormLabel>
                                                      </div>

                                                      <div className="col-md-6">
                                                        <RadioGroup
                                                          row
                                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                                          name="row-radio-buttons-group" className='radio-secss'
                                                        >
                                                          <FormControlLabel value="Yes"



                                                            name="coronavirus_hospitalized" checked={fifthformInfo.coronavirus_hospitalized == 'Yes'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                          <FormControlLabel value="No"


                                                            name="coronavirus_hospitalized" checked={fifthformInfo.coronavirus_hospitalized == 'No'}
                                                            onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                          <div className='fied-miss'>
                                                            {fifthformInfo.coronavirus_hospitalized_error == true ? 'Field missing' : ''}
                                                          </div>

                                                        </RadioGroup>



                                                      </div>
                                                    </div>



                                                  </FormControl>
                                                </div>

                                                {fifthformInfo.coronavirus_hospitalized == 'Yes' ?

                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div class="std-form-inner address-sec explain-sec">
                                                        <label>Describe in detail

                                                        </label>
                                                        <p class="float-left">:</p>
                                                        <textarea class="new-textara-inpt"
                                                          value={fifthformInfo.explain_coronavirus_hospitalized} onChange={handleChangeFifth}
                                                          name="explain_coronavirus_hospitalized" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                        <p className='error-msg-frm error-msg-frm-top'>
                                                          <span>
                                                            {fifthformInfo.explain_coronavirus_hospitalized_error == true ? 'Please enter the explanation' : ''}
                                                          </span>
                                                        </p>
                                                      </div>

                                                    </div>
                                                  </div>
                                                  : ''}

                                              </div>

                                              <div class="sign-sec-main sign-new-sec">
                                                <div class="row">
                                                  <div class="col-md-9">
                                                    <div class="sign-sec">
                                                      <p>Signature of Parent/Guardian  </p>
                                                      <p class="colon-sec">:</p>
                                                      <input class="text-input-sign cusrive-font-sec"
                                                        value={fifthformInfo.parent_signature} onChange={handleChangeFifth}
                                                        name="parent_signature" type="text" id="fname" placeholder="" />
                                                      <p className='error-msg-frm erro-nau'>
                                                        <span>
                                                          {fifthformInfo.parent_signature_error == true ? 'Please enter the Signature of Parent/Guardian ' : ''}

                                                        </span>
                                                      </p>

                                                    </div>
                                                  </div>
                                                  <div class="col-md-3">
                                                    <div className='form-date-sec form-date-nbw'>
                                                      <label >Date </label>

                                                      <div className='sign-sec'>

                                                        <p className='colon-sec'>:</p>
                                                        <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>


                                              <div className='row'>
                                                <div className='col-md-12'>
                                                  <div class="login-submit login-submitss login-toltip">


                                                    <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitFifth}>Submit
                                                      {
                                                        parentLoaderFifth != '' ?
                                                          <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                          : ''

                                                      }
                                                    </button>

                                                  </div>
                                                  {
                                                    successMsgFifth != '' ? <div className="success-msg success-login form-success">
                                                      <p className="success-msg success-login">{successMsgFifth}</p>
                                                    </div> : ''
                                                  }


                                                  {
                                                    errorMsgFifth != '' ? <div className="error-msg error-login form-error" >
                                                      <p className="error-msg error-login">{errorMsgFifth}</p>
                                                    </div> : <div className="error-msg error-login form-error" style={{ visibility: 'hidden' }} >
                                                      <p className="error-msg error-login">Wrong credentials!</p>
                                                    </div>
                                                  }

                                                </div>
                                              </div>






                                            </div>
                                          </div>


                                        </Typography>
                                      </AccordionDetails>
                                    </Accordion>
                                  </>
                                }
                                {(formtimecheck != 'first' && formtimecheck != '') &&

                                  <>

                                    <Accordion expanded={expandednew === 'panel5f'} onChange={handleChangenew('panel5f')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel3-content"
                                        id="panel3-header"
                                      >
                                        <Typography sx={{ width: '80%', flexShrink: 0 }}>NEW JERSEY DEPARTMENT OF EDUCATION HEALTH HISTORY UPDATE QUESTIONNAIRE</Typography>
                                        <Typography className="green-dwn" sx={{ flexShrink: 0, color: 'text.secondary', float: 'right', width: '20%', textAlign: 'right', color: '#008430', fontWeight: '600' }} >
                                          {(formcheck != null) ?

                                            'Completed' : <span className='pebdingarmh'>Pending</span>}
                                        </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <Typography>
                                          <div className='form-main-sec'>
                                            <div className='date-form'>






                                              {(formcheck != null) ?

                                                '' : <>
                                                  <div className='row'>
                                                    <div className='col-md-2'>
                                                      <div className='heading-logo'>
                                                        <img src={newlogos} style={{ top: '15px' }} />
                                                      </div>
                                                    </div>
                                                    <div className='col-md-8'>
                                                      <div className='heading-form-para'>
                                                        <h1>New Jersey Department of Education </h1>
                                                        <h2>HEALTH HISTORY UPDATE QUESTIONNAIRE</h2>


                                                      </div>
                                                    </div>

                                                  </div>
                                                  <div className='row'>


                                                    <div class="form-date-sec update-schl">
                                                      <label>Name of School</label>
                                                      <span className='colon'>:</span>
                                                      <span className='schol-name '>{userData.school_name}</span></div>
                                                  </div>
                                                  <div className='row'>
                                                    <div className='col-md-12'>
                                                      <div className='form-content-sec form-content-secss'>
                                                        <p>To participate on a school-sponsored interscholastic or intramural athletic team or squad, each student whose physical examination was completed more than 90 days prior
                                                          to the first day of official practice shall provide a health history update questionnaire completed and signed by the student's parent or guardian.</p>
                                                      </div>
                                                    </div>
                                                  </div>


                                                  <div class="row margin-data ques-margin-dta">
                                                    <div class="col-md-3">

                                                      <div class="form-inner ony-wid-main">
                                                        <h2 className='ony-wid-name ony-wid-namess'>Student Name</h2>
                                                        <p>:</p>
                                                        <p class="id-sec width-extra ony-wid-exta">{userData.student_name} {userData.last_name}</p></div>
                                                    </div>
                                                    <div class="col-md-2">

                                                      <div class="form-inner new-form-inner extranew-inn">
                                                        <h2>Age </h2>
                                                        <p>:</p>
                                                        <p class="form-data width-extra"> {(userData.dob != null && userData.dob != '') && ageCalculator(userData.dob)}</p>
                                                      </div>
                                                    </div>
                                                    <div class="col-md-2">

                                                      <div class="form-inner new-form-inner extranew-inns">
                                                        <h2>Grade</h2>
                                                        <p>:</p>
                                                        <p class="id-sec width-extra"> {userData.stu_grade}</p>
                                                      </div>
                                                    </div>
                                                    <div class="col-md-5">



                                                      <div className='form-date-sec form-date-nbw'>
                                                        <label className="width-labl" style={{ top: '3px' }}>Date of Last Physical Examination</label>

                                                        <div className='date-sec date-text-nwd'>
                                                          <div className='date-slash'>
                                                            <input type="text" className="textmntg"
                                                              id="datefir_fif" onKeyPress={(e) => handleKeyAccountPress(e)} placeholder='m'
                                                              value={fifthformInfo.datefir} onChange={handleChangeFifth}
                                                              name="datefir" />
                                                            <input type="text" onKeyPress={(e) => handleKeyAccountPress(e)} className="textmntg" placeholder='m'
                                                              value={fifthformInfo.datesec} id="datesec_fif"
                                                              onChange={handleChangeFifth}
                                                              name="datesec" />

                                                          </div>
                                                          <div className='date-slash'>
                                                            <p >-</p>
                                                          </div>
                                                          <div className='date-slash'>
                                                            <input type="text" className="textdate textmonthstg" placeholder='d'
                                                              value={fifthformInfo.dateth} id="dateth_fif" onKeyPress={(e) => handleKeyAccountPress(e)}
                                                              onChange={handleChangeFifth}
                                                              name="dateth" />
                                                            <input type="text" id="datefor_fif" className="textdate textmonthstg" placeholder='d'
                                                              value={fifthformInfo.datefor} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeFifth}
                                                              name="datefor" />
                                                          </div>
                                                          <div className='date-slash'>
                                                            <p >-</p>
                                                          </div>
                                                          <div className='date-slash'>
                                                            <input type="text" id="datefif_fif" className="textdate textyeartg" placeholder='y'
                                                              value={fifthformInfo.datefif} onKeyPress={(e) => handleKeyAccountPress(e)} onChange={handleChangeFifth}
                                                              name="datefif" />
                                                            <input type="text" id="datesix_fif" className="textdate textyeartg" placeholder='y'
                                                              value={fifthformInfo.datesix} onChange={handleChangeFifth} onKeyPress={(e) => handleKeyAccountPress(e)}
                                                              name="datesix" />
                                                            <input type="text" id="dateseven_fif" className="textdate textyeartg"
                                                              value={fifthformInfo.dateseven} onChange={handleChangeFifth} onKeyPress={(e) => handleKeyAccountPress(e)}
                                                              name="dateseven" placeholder='y' />
                                                            <input type="text" id="dateeight_fif" className="textdate textyeartg"
                                                              value={fifthformInfo.dateeight} onChange={handleChangeFifth} onKeyPress={(e) => handleKeyAccountPress(e)}
                                                              name="dateeight" placeholder='y' />
                                                          </div>


                                                        </div>


                                                      </div>

                                                      <p className='error-msg-frm ' style={{ textAlign: 'center' }}>
                                                        <span>
                                                          {fifthformInfo.datefir_error == true ? 'Please enter date of last physical examination' : ''}
                                                        </span>
                                                      </p>

                                                    </div>

                                                  </div>
                                                  <div class="row margin-data">
                                                    <div class="col-md-6">

                                                      <div class="form-inner form-date-sec form-sportss form-new-sportsss">
                                                        <h2>Sport(s)</h2>
                                                        <p>:</p>
                                                        <input type="text" class="text-datess new-border"
                                                          value={fifthformInfo.sports} onChange={handleChangeFifth}
                                                          name="sports" />
                                                        <div style={{ position: 'relative', display: 'block' }} >
                                                          <p className='error-msg-frm error-sbso ' style={{ textAlign: 'center', marginLeft: '0px', position: 'absolute' }}>
                                                            {fifthformInfo.sports_error == true ? 'Please enter the sports' : ''}

                                                          </p>
                                                        </div>

                                                      </div>
                                                    </div>

                                                  </div>
                                                  <div class="row">
                                                    <div class="col-md-12">
                                                      <div class="physici-sec-head">
                                                        <h2>Since the last pre-participation physical examination, has your son/daughter</h2>
                                                      </div>
                                                    </div>
                                                  </div>



                                                  <div className='medi-details-sec gener-ques'>


                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">1.</p><p class="num-data-sec"> Been medically advised not to participate in a sport?</p>
                                                            </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="advised_not_participate" checked={fifthformInfo.advised_not_participate == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="advised_not_participate" checked={fifthformInfo.advised_not_participate == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />


                                                              <div className='fied-miss'>
                                                                {fifthformInfo.advised_not_participate_error == true ? 'Field missing ' : ''}
                                                              </div>

                                                            </RadioGroup>



                                                          </div>
                                                        </div>


                                                        {fifthformInfo.advised_not_participate == 'Yes' ?

                                                          <div className='row'>
                                                            <div className='col-md-12'>
                                                              <div class="std-form-inner address-sec">
                                                                <label>Describe in detail

                                                                </label>
                                                                <p class="float-left">:</p>
                                                                <textarea class="new-textara-inpt"
                                                                  value={fifthformInfo.explain_advised_not_participate}
                                                                  onChange={handleChangeFifth}
                                                                  name="explain_advised_not_participate" type="text" id="fname"
                                                                  placeholder="" rows="4" cols="50"></textarea>
                                                                <p className='error-msg-frm error-msg-frm-top'>
                                                                  <span>
                                                                    {fifthformInfo.explain_advised_not_participate_error == true ? 'Please enter the explanation' : ''}
                                                                  </span>
                                                                </p>
                                                              </div>

                                                            </div>
                                                          </div>
                                                          : ''}

                                                      </FormControl>
                                                    </div>

                                                    <div class="" style={{ marginTop: '0px' }}>
                                                      <hr />
                                                    </div>
                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">2.</p><p class="num-data-sec"> Sustained a concussion, been unconscious or lost memory from a blow to the head? </p>
                                                            </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="sustained_lost_memory" checked={fifthformInfo.sustained_lost_memory == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="sustained_lost_memory" checked={fifthformInfo.sustained_lost_memory == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                              <div className='fied-miss'>
                                                                {fifthformInfo.sustained_lost_memory_error == true ? 'Field missing ' : ''}
                                                              </div>

                                                            </RadioGroup>



                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>

                                                    {fifthformInfo.sustained_lost_memory == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_sustained_lost_memory} onChange={handleChangeFifth}
                                                              name="explain_sustained_lost_memory" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_sustained_lost_memory_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}
                                                    <div class="" style={{ marginTop: '0px' }}>
                                                      <hr />
                                                    </div>

                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">3.</p><p class="num-data-sec"> Broken a bone or sprained/strained/dislocated any muscle or joints? </p>
                                                            </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="broken_bone" checked={fifthformInfo.broken_bone == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="broken_bone" checked={fifthformInfo.broken_bone == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                              <div className='fied-miss'>
                                                                {fifthformInfo.broken_bone_error == true ? 'Field missing' : ''}
                                                              </div>

                                                            </RadioGroup>



                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>

                                                    {fifthformInfo.broken_bone == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_broken_bone} onChange={handleChangeFifth}
                                                              name="explain_broken_bone" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_broken_bone_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}
                                                    <div class="" style={{ marginTop: '0px' }}>
                                                      <hr />
                                                    </div>

                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">4.</p><p class="num-data-sec"> Fainted or "blacked out?"  </p>
                                                            </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="fainted" checked={fifthformInfo.fainted == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="fainted" checked={fifthformInfo.fainted == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                              <div className='fied-miss'>
                                                                {fifthformInfo.fainted_error == true ? 'Field missing' : ''}
                                                              </div>
                                                            </RadioGroup>



                                                          </div>
                                                        </div>


                                                        {fifthformInfo.fainted == 'Yes' ?

                                                          <div className='row'>
                                                            <div className='col-md-12'>
                                                              <div class="std-form-inner address-sec">
                                                                <label>If yes, was this during or immediately after exercise?

                                                                </label>
                                                                <p class="float-left">:</p>
                                                                <textarea class="new-textara-inpt"
                                                                  value={fifthformInfo.explain_fainted} onChange={handleChangeFifth}
                                                                  name="explain_fainted" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                                <p className='error-msg-frm error-msg-frm-top'>
                                                                  <span>
                                                                    {fifthformInfo.explain_fainted_error == true ? 'Please enter the explanation' : ''}
                                                                  </span>
                                                                </p>
                                                              </div>

                                                            </div>
                                                          </div>
                                                          : ''}


                                                      </FormControl>
                                                    </div>
                                                    <div class="" style={{ marginTop: '0px' }}>
                                                      <hr />
                                                    </div>
                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">5.</p><p class="num-data-sec">  Experienced chest pains, shortness of breath or "racing heart?"  </p>
                                                            </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="chest_pains" checked={fifthformInfo.chest_pains == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="chest_pains" checked={fifthformInfo.chest_pains == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                              <div className='fied-miss'>
                                                                {fifthformInfo.chest_pains_error == true ? 'Field missing' : ''}
                                                              </div>

                                                            </RadioGroup>


                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>

                                                    {fifthformInfo.chest_pains == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_chest_pains} onChange={handleChangeFifth}
                                                              name="explain_chest_pains" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_chest_pains_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}
                                                    <div class="" style={{ marginTop: '0px' }}>
                                                      <hr />
                                                    </div>
                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">6.</p><p class="num-data-sec"> Has there been a recent history of fatigue and unusual tiredness?  </p>
                                                            </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="unusual_tiredness" checked={fifthformInfo.unusual_tiredness == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="unusual_tiredness" checked={fifthformInfo.unusual_tiredness == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                              <div className='fied-miss'>
                                                                {fifthformInfo.unusual_tiredness_error == true ? 'Field missing' : ''}
                                                              </div>

                                                            </RadioGroup>


                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>

                                                    {fifthformInfo.unusual_tiredness == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_unusual_tiredness} onChange={handleChangeFifth}
                                                              name="explain_unusual_tiredness" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_unusual_tiredness_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}
                                                    <div class="" style={{ marginTop: '0px' }}>
                                                      <hr />
                                                    </div>
                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">7.</p><p class="num-data-sec"> Been hospitalized or had to go to the emergency room?</p>
                                                            </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="emergency_room" checked={fifthformInfo.emergency_room == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="emergency_room" checked={fifthformInfo.emergency_room == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                              <div className='fied-miss'>
                                                                {fifthformInfo.emergency_room_error == true ? 'Field missing' : ''}
                                                              </div>

                                                            </RadioGroup>



                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>

                                                    {fifthformInfo.emergency_room == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_emergency_room} onChange={handleChangeFifth}
                                                              name="explain_emergency_room" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_emergency_room_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}
                                                    <div class="" style={{ marginTop: '0px' }}>
                                                      <hr />
                                                    </div>

                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">8.</p><p class="num-data-sec"> Since the last physical examination, has there been a sudden death in the family or has any member of the family under age
                                                                50 had a heart attack or "heart trouble?" </p></FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="sudden_death_any_member" checked={fifthformInfo.sudden_death_any_member == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="sudden_death_any_member" checked={fifthformInfo.sudden_death_any_member == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                              <div className='fied-miss'>
                                                                {fifthformInfo.sudden_death_any_member_error == true ? 'Field missing ' : ''}
                                                              </div>
                                                            </RadioGroup>


                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>

                                                    {fifthformInfo.sudden_death_any_member == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_sudden_death_any_member} onChange={handleChangeFifth}
                                                              name="explain_sudden_death_any_member" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_sudden_death_any_member_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}
                                                    <div class="" style={{ marginTop: '0px' }}>
                                                      <hr />
                                                    </div>

                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">9.</p><p class="num-data-sec"> Started or stopped taking any over-the-counter or prescribed medications?</p>  </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="prescribed_medications" checked={fifthformInfo.prescribed_medications == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="prescribed_medications" checked={fifthformInfo.prescribed_medications == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />
                                                              <div className='fied-miss'>
                                                                {fifthformInfo.prescribed_medications_error == true ? 'Field missing ' : ''}
                                                              </div>
                                                            </RadioGroup>



                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>


                                                    {fifthformInfo.prescribed_medications == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_prescribed_medications} onChange={handleChangeFifth}
                                                              name="explain_prescribed_medications" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_prescribed_medications_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}
                                                    <div class="" style={{ marginTop: '0px' }}>
                                                      <hr />
                                                    </div>

                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              <p class="num-sec">10.</p><p class="num-data-sec">   Been diagnosed with Coronavirus (COVID-19)? </p>   </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="been_coronavirus" checked={fifthformInfo.been_coronavirus == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="been_coronavirus" checked={fifthformInfo.been_coronavirus == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                              <div className='fied-miss'>
                                                                {fifthformInfo.been_coronavirus_error == true ? 'Field missing ' : ''}
                                                              </div>

                                                            </RadioGroup>


                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>

                                                    {fifthformInfo.been_coronavirus == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_been_coronavirus} onChange={handleChangeFifth}
                                                              name="explain_been_coronavirus" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_been_coronavirus_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}

                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              If diagnosed with Coronavirus (COVID-19), was your son/daughter symptomatic? </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="coronavirus_symptomatic" checked={fifthformInfo.coronavirus_symptomatic == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="coronavirus_symptomatic" checked={fifthformInfo.coronavirus_symptomatic == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                              <div className='fied-miss'>
                                                                {fifthformInfo.coronavirus_symptomatic_error == true ? 'Field missing' : ''}
                                                              </div>

                                                            </RadioGroup>



                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>

                                                    {fifthformInfo.coronavirus_symptomatic == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec explain-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_coronavirus_symptomatic} onChange={handleChangeFifth}
                                                              name="explain_coronavirus_symptomatic" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_coronavirus_symptomatic_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}


                                                    <div className='radio-sec-medi-details radio-above'>
                                                      <FormControl>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <FormLabel id="demo-row-radio-buttons-group-label" className='radio-label'>
                                                              If diagnosed with Coronavirus (COVID-19), was your son/daughter hospitalized?  </FormLabel>
                                                          </div>

                                                          <div className="col-md-6">
                                                            <RadioGroup
                                                              row
                                                              aria-labelledby="demo-row-radio-buttons-group-label"
                                                              name="row-radio-buttons-group" className='radio-secss'
                                                            >
                                                              <FormControlLabel value="Yes"



                                                                name="coronavirus_hospitalized" checked={fifthformInfo.coronavirus_hospitalized == 'Yes'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="Yes" />
                                                              <FormControlLabel value="No"


                                                                name="coronavirus_hospitalized" checked={fifthformInfo.coronavirus_hospitalized == 'No'}
                                                                onChange={handleChangeFifth} control={<Radio />} label="No" />

                                                              <div className='fied-miss'>
                                                                {fifthformInfo.coronavirus_hospitalized_error == true ? 'Field missing' : ''}
                                                              </div>

                                                            </RadioGroup>



                                                          </div>
                                                        </div>



                                                      </FormControl>
                                                    </div>

                                                    {fifthformInfo.coronavirus_hospitalized == 'Yes' ?

                                                      <div className='row'>
                                                        <div className='col-md-12'>
                                                          <div class="std-form-inner address-sec explain-sec">
                                                            <label>Describe in detail

                                                            </label>
                                                            <p class="float-left">:</p>
                                                            <textarea class="new-textara-inpt"
                                                              value={fifthformInfo.explain_coronavirus_hospitalized} onChange={handleChangeFifth}
                                                              name="explain_coronavirus_hospitalized" type="text" id="fname" placeholder="" rows="4" cols="50"></textarea>
                                                            <p className='error-msg-frm error-msg-frm-top'>
                                                              <span>
                                                                {fifthformInfo.explain_coronavirus_hospitalized_error == true ? 'Please enter the explanation' : ''}
                                                              </span>
                                                            </p>
                                                          </div>

                                                        </div>
                                                      </div>
                                                      : ''}

                                                  </div>

                                                  <div class="sign-sec-main sign-new-sec">
                                                    <div class="row">
                                                      <div class="col-md-9">
                                                        <div class="sign-sec">
                                                          <p>Signature of Parent/Guardian  </p>
                                                          <p class="colon-sec">:</p>
                                                          <input class="text-input-sign cusrive-font-sec"
                                                            value={fifthformInfo.parent_signature} onChange={handleChangeFifth}
                                                            name="parent_signature" type="text" id="fname" placeholder="" />
                                                          <p className='error-msg-frm erro-nau'>
                                                            <span>
                                                              {fifthformInfo.parent_signature_error == true ? 'Please enter the Signature of Parent/Guardian ' : ''}

                                                            </span>
                                                          </p>

                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div className='form-date-sec form-date-nbw'>
                                                          <label >Date </label>

                                                          <div className='sign-sec'>

                                                            <p className='colon-sec'>:</p>
                                                            <p style={{ fontWeight: '400', marginLeft: '9px', paddingTop: '7px' }}>{formDate}</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>}

                                              <div className='row'>
                                                <div className='col-md-12'>
                                                  <div class="login-submit login-submitss login-toltip">

                                                    {formcheck != null && formtimecheck == 'second' && horcheck == true &&
                                                      <>
                                                        <button class="btn btn-login btn-submit bt-forms bt-fill-newfrms btn-edits"
                                                          onClick={(e) => handleOpenLogacc(5)}
                                                        >EDIT</button>
                                                        <a title="Download"
                                                          onClick={(e) => handleDownloadFileconscent(formcheck.child_id, 5, formcheck.document,formcheck.id)}
                                                          target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>

                                                      </>
                                                    }
                                                    {formcheck != null && (formtimecheck == 'third') && horcheck == true &&
                                                      <>
                                                     
                                                        <a title="Download"
                                                          onClick={(e) => handleDownloadFileconscent(formcheck.child_id, 5, formcheck.document,formcheck.id)}
                                                          target="_blank" class="btn btn-cancel btn-login btn-down"><PictureAsPdfIcon />Form Download</a>

                                                      </>
                                                    }
                                                    {formcheck == null &&
                                                      <>

                                                        <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmitFifth}>Submit
                                                          {
                                                            parentLoaderFifth != '' ?
                                                              <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                              : ''

                                                          }
                                                        </button>

                                                      </>
                                                    }

                                                  </div>
                                                  {
                                                    successMsgFifth != '' ? <div className="success-msg success-login form-success">
                                                      <p className="success-msg success-login">{successMsgFifth}</p>
                                                    </div> : ''
                                                  }


                                                  {
                                                    errorMsgFifth != '' ? <div className="error-msg error-login form-error" >
                                                      <p className="error-msg error-login">{errorMsgFifth}</p>
                                                    </div> : <div className="error-msg error-login form-error" style={{ visibility: 'hidden' }} >
                                                      <p className="error-msg error-login">Wrong credentials!</p>
                                                    </div>
                                                  }

                                                </div>
                                              </div>






                                            </div>
                                          </div>


                                        </Typography>
                                      </AccordionDetails>
                                    </Accordion>
                                  </>
                                }




                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                    </>
                  }
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* modal section for reason start here */}

      <BootstrapDialog
        onClose={handleCloselogss}
        aria-labelledby="customized-dialog-title"
        open={reason} className="route-view copy-view logout-view login-modal app-modal">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselogss}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec' style={{ paddingTop: '0px' }}>
              {reasondeatils != null && reasondeatils != '' &&
                <>
                  {
                    reasondeatils.status == 'Approved' ?
                      <h2 className='uplod-secddd'>Approval Feedback</h2>
                      :
                      <h2 className='uplod-secddd'>Reason For Rejection</h2>
                  }
                  <p className='uplod-para approv-fed'>{reasondeatils.reason}</p>
                </>
              }
            </div>
          </Typography>
        </DialogContent>
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleCloselog}
        aria-labelledby="customized-dialog-title"
        open={openLog} className="route-view copy-view logout-view  club-modal clear-form">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselog}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
              {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}

              <h2>Please wait, while we check your form</h2>


              <div className='check-sec modal-check-sec'>


                <div className='row'>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear'>

                    </div>
                  </div>
                </div>
              </div>
            </div>


          </Typography>
        </DialogContent>
      </BootstrapDialog>



      <BootstrapDialog
        onClose={handleCloselogaccb}
        aria-labelledby="customized-dialog-title"
        open={openLogacc} className="route-view copy-view logout-view  club-modal clear-form new-form-modal under-main">
        <BootstrapDialogTitle className="close-routeview fill-cls-rut" id="customized-dialog-title" onClose={handleCloselogaccb}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec fill-sec' style={{ paddingTop: '0px' }}>
              {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}

              <h2 style={{ paddingTop: '5px' }}>Filling up a new Form</h2>


              <div className='check-sec modal-check-sec'>


                <div className='row'>
                  <div className='col-md-12' style={{ marginTop: '12px', marginBottom: '8px' }}>
                    <p className="para-fill">I understand that I will be filling up a new form and my previous form will be not be available for use. Furthermore I will not be able to make anymore changes to this Form.  </p>

                  </div>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear understnd-sec' style={{ marginTop: '0px', marginBottom: '10px' }}>
                      {/* <button className='btn btn-cancel btn-login btn-down btn-no btn-cancl' onClick={() => {handleCloselogaccb()}}>CANCEL</button>
                     */}
                      <FormGroup className='radio-sec'>
                        <FormControlLabel label="I understand" control={<Checkbox />}
                          checked={checkprf} onChange={handleChangecheckpr} />

                      </FormGroup>
                      <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                        disabled={checkprf == false ? 'disabled' : false} onClick={() => { handleEdit(valueacc) }}>PROCEED </button>

                    </div>
                  </div>
                </div>
              </div>
            </div>


          </Typography>
        </DialogContent>
      </BootstrapDialog>
      {/* modal section for reason end here */}

    </>
  );
}
export default FormStatus;